import { type CSSProperties } from 'typestyle/lib/types';
import StyleConstants from './styles.constants';

class CommonStyles {
  public static pageMargin = {
    marginTop: 95,
    marginBottom: 24,
    paddingBottom: 119,
  };

  public static bodyMargin(isMobile: boolean): CSSProperties {
    return {
      marginLeft: isMobile ? 16 : 56,
      marginRight: isMobile ? 16 : 56,
      marginTop: isMobile ? 16 : 33,
    };
  }

  public static sectionCard(isMobile: boolean, width?: number): CSSProperties {
    return {
      marginTop: 12,
      marginBottom: 12,
      padding: isMobile ? 12 : 24,
      background: StyleConstants.WHITE_COLOR,
      boxShadow: '1px 2px 15px rgba(0, 0, 0, 0.1)',
      borderRadius: 8,
      width: isMobile ? '100%' : width ?? '100%',
    };
  }
}

export default CommonStyles;
